import { createFileRoute } from "@tanstack/react-router"
import { TopicPage } from "~/features/topic/components/topic-page"

export const Route = createFileRoute("/topic/$id")({
  component: TopicPage,
})
